import React from "react";
import '../../assets/scss/purpleTheme/components/card.scss'

const CardHeader = (props) => {
  return(
    <div className="cardhead">
      {props.children}
    </div>
  )
}

export default CardHeader;